<div class="chartWrapper">
  <ul
    class="c-tabs"
    data-tabs="tabs"
    data-automation-e2e-selector="gamedaySubnavigation"
  >
    <li class="c-tab-item">
      <a
        (click)="priorityType()"
        class="c-tab-item-link c-cursor-pointer"
        [ngClass]="(viewType | async) === viewTypes.PriorityType ? 'c-tab-item-link-active' : ''"
        data-automation-e2e-selector="overviewPageTab"
      >
        Overview
      </a>
    </li>
    <li class="c-tab-item">
      <a
        (click)="retailType()"
        class="c-tab-item-link c-cursor-pointer"
        [ngClass]="(viewType | async) === viewTypes.RetailType ? 'c-tab-item-link-active' : ''"
        data-automation-e2e-selector="retailPageTab"
      >
        Retail
      </a>
    </li>
    <li class="c-tab-item">
      <a
        (click)="managerType()"
        class="c-tab-item-link c-cursor-pointer"
        [ngClass]="(viewType | async) === viewTypes.ManagersType ? 'c-tab-item-link-active' : ''"
        data-automation-e2e-selector="managersPageTab"
      >
        Managers
      </a>
    </li>
    <li class="c-tab-item">
      <a
        (click)="moneyType()"
        class="c-tab-item-link c-cursor-pointer"
        [ngClass]="(viewType | async) === viewTypes.MoneyType ? 'c-tab-item-link-active' : ''"
        data-automation-e2e-selector="moneyTypePageTab"
      >
        Investors
      </a>
    </li>
    <li class="c-tab-item right">
      <muni-gameday-search-by-account-manager>
      </muni-gameday-search-by-account-manager>
    </li>
  </ul>
  <div class="chartCont" id="overview">
    <div class="chartInnerCont">
      <muni-gameday-loading [visible]="(loading | async)">
        <muni-gameday-combine-bar-chart
          [hidden]="emptyChartMessage | async"
          [config]="config"
          [data]="chartObservable | async"
          (events)="handleEvents($event)"
          data-automation-e2e-selector="chartSet"
        >
        </muni-gameday-combine-bar-chart>
        <span
          class="empty"
          [hidden]="!(emptyChartMessage | async)"
          [textContent]="emptyChartMessage | async"
        >
        </span>
      </muni-gameday-loading>
    </div>
    <muni-gameday-combine-tranches></muni-gameday-combine-tranches>
  </div>
</div>
